import { type ReportHandler } from 'web-vitals'

export default async function reportWebVitals(onPerfEntry?: ReportHandler): Promise<void> {
  if (onPerfEntry != null && onPerfEntry instanceof Function) {
    const { getCLS, getFID, getFCP, getLCP, getTTFB } = await import('web-vitals')
      .catch(err => { throw err })

    getCLS(onPerfEntry)
    getFID(onPerfEntry)
    getFCP(onPerfEntry)
    getLCP(onPerfEntry)
    getTTFB(onPerfEntry)
  }
}
